import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'submit'
  ]

  trackQuestionInput(event) {
    if (event.currentTarget.value.length > 3) {
      this.submitTarget.disabled = false
    } else {
      this.submitTarget.disabled = true
    }
  }

  submit() {
    this.submitTarget.click()
  }
}
